import { createAction, props } from '@ngrx/store';
import {
  CreateAppointmentDto,
  IAppointment,
  UpdateAppointmentDTO
} from '@care-portals/api-interfaces';

/* ----------------------------- Get Appointment By Id ----------------------------- */

export const getAppointmentById = createAction(
  '[Appointments] Get Appointment By Id',
  props<{ id: string }>()
);

export const getAppointmentByIdSuccess = createAction(
  '[Appointments] Get Appointment By Id Success',
  props<{ appointment: IAppointment }>()
);

export const getAppointmentByIdFailure = createAction(
  '[Appointments] Get Appointment By Id Failure',
  props<{ error: Error }>()
);
/* ----------------------------- Get All Appointments ----------------------------- */

export const loadAppointments = createAction(
  '[Appointment] Load Appointments',
  props<{ filters: any }>()
);

export const loadAppointmentsSuccess = createAction(
  '[Appointment] Load Appointments Success',
  props<{ appointments: IAppointment[] }>()
);

export const loadAppointmentsFailure = createAction(
  '[Appointment] Load Appointments Failure',
  props<{ error: any }>()
);

export const fetchMySeenTodayAppointments = createAction(
  '[Appointment] Fetch My Today Appointment'
);

export const fetchMySeenTodayAppointmentsSuccess = createAction(
  '[Appointment] Fetch My Today Appointment Success',
  props<{ appointments: IAppointment[] }>()
);

export const fetchMySeenTodayAppointmentsFailure = createAction(
  '[Appointment] Fetch My Today Appointment Failure',
  props<{ error: any }>()
);

export const saveAppointment = createAction(
  '[Appointment] Save Appointment',
  props<{ appointment: CreateAppointmentDto }>()
);

export const saveAppointmentSuccess = createAction(
  '[Appointment] Save Appointment Success',
  props<{ appointment: IAppointment }>()
);

export const saveAppointmentFailure = createAction(
  '[Appointment] Save Appointment Failure',
  props<{ error: any }>()
);

export const createAppointment = createAction(
  '[Appointment] Create Appointment',
  props<{ appointment: CreateAppointmentDto }>()
);

export const createAppointmentSuccess = createAction(
  '[Appointment] Create Appointment Success',
  props<{ appointment: IAppointment }>()
);

export const createAppointmentFailure = createAction(
  '[Appointment] Create Appointment Failure',
  props<{ error: any }>()
);

export const updateAppointment = createAction(
  '[Appointment] Update Appointment',
  props<{ id: string; appointment: UpdateAppointmentDTO }>()
);

export const updateAppointmentSuccess = createAction(
  '[Appointment] Update Appointment Success',
  props<{ appointment: IAppointment }>()
);

export const updateAppointmentFailure = createAction(
  '[Appointment] Update Appointment Failure',
  props<{ error: any }>()
);

export const pullAppointment = createAction('[Appointment] Pull Appointment');

export const pullAppointmentSuccess = createAction(
  '[Appointment] Pull Appointment Success',
  props<{ appointment: IAppointment }>()
);

export const pullAppointmentFailure = createAction(
  '[Appointment] PULL Appointment Failure',
  props<{ error: any }>()
);

export const stitchInit = createAction('[Appointment] Stitch Initialize');

export const stitchInitSuccess = createAction(
  '[Appointment] Stitch Initialize Success'
);

export const stitchInitFailure = createAction(
  '[Appointment] Stitch Initialize Failure',
  props<{ error: any }>()
);

export const clearAppointment = createAction('[Appointment] Clear Appointment');

export const nullAction = createAction('[Appointment] Null');
